import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import withRouter from '../Components/Common/withRouter';


//import Components
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import RightSidebar from '../Components/Common/RightSidebar';
import MobileFooter from './MobileFooter';

//import actions
import {
    changeLayout,
    changeSidebarTheme,
    changeLayoutMode,
    changeLayoutWidth,
    changeLayoutPosition,
    changeTopbarTheme,
    changeLeftsidebarSizeType,
    changeLeftsidebarViewType,
    changeSidebarImageType,
    changeSidebarVisibility
} from "../slices/thunks";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';
import { useLocation, useNavigate } from 'react-router-dom';
import ChangePassword from 'pages/AuthenticationInner/ChangePassword';


const Layout = (props: any) => {
    const selectUser = createSelector(
        (state) => state.User,
        (user) => user?.user
    );
    const authUserLoadedSelector = createSelector(
        (state) => state.User,
        (user) => user?.isUserLoaded
    );
    const dispatch: any = useDispatch();
    const selectLayoutState = (state: any) => state.Layout;
    const user = useSelector(selectUser);
    const isUserLoaded = useSelector(authUserLoadedSelector);
    const location = useLocation();
    const navigate = useNavigate();
    const [showSidebar, setSidebar] = useState(true);
    const isSetSellerStore = location.pathname === '/set-seller-store';
    const isOnBoarding = location.pathname === '/on-boarding';
     const isChangePassword = location.pathname === '/change-password';


    useEffect(() => {
        if (isUserLoaded) {
            if (user && user.storeStatus) {
                const { isAddressAdded, isIdBankDetails, isProductAdded, isStoreCreated } = user?.storeStatus || {};
                if (!isStoreCreated) {
                    if (location.pathname !== '/set-seller-store') {
                        navigate("/set-seller-store");
                    }
                    setSidebar(false);
                } else if (
                    !isAddressAdded ||
                    !isIdBankDetails 
                    // ||
                    // !isProductAdded
                ) {
                    setSidebar(false);
                    if (location.pathname !== '/on-boarding') {
                        navigate("/on-boarding");
                    }
                } else {
                    setSidebar(true);
                }
            }
        }
    }, [user])


    useEffect(() => {
    }, [user]);

    const selectLayoutProperties = createSelector(
        selectLayoutState,
        (layout) => ({
            layoutType: layout.layoutType,
            leftSidebarType: layout.leftSidebarType,
            layoutModeType: layout.layoutModeType,
            layoutWidthType: layout.layoutWidthType,
            layoutPositionType: layout.layoutPositionType,
            topbarThemeType: layout.topbarThemeType,
            leftsidbarSizeType: layout.leftsidbarSizeType,
            leftSidebarViewType: layout.leftSidebarViewType,
            leftSidebarImageType: layout.leftSidebarImageType,
            preloader: layout.preloader,
            sidebarVisibilitytype: layout.sidebarVisibilitytype,
        })
    );
    // Inside your component
    const {
        layoutType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        leftsidbarSizeType,
        leftSidebarViewType,
        leftSidebarImageType,
        // preloader,
        sidebarVisibilitytype
    } = useSelector(selectLayoutProperties);

    /*
    layout settings
    */
    useEffect(() => {
        if (
            layoutType ||
            leftSidebarType ||
            layoutModeType ||
            layoutWidthType ||
            layoutPositionType ||
            topbarThemeType ||
            leftsidbarSizeType ||
            leftSidebarViewType ||
            leftSidebarImageType ||
            sidebarVisibilitytype
        ) {
            window.dispatchEvent(new Event('resize'));
            dispatch(changeLeftsidebarViewType(leftSidebarViewType));
            dispatch(changeLeftsidebarSizeType(leftsidbarSizeType));
            dispatch(changeSidebarTheme(leftSidebarType));
            dispatch(changeLayoutMode(layoutModeType));
            dispatch(changeLayoutWidth(layoutWidthType));
            dispatch(changeLayoutPosition(layoutPositionType));
            dispatch(changeTopbarTheme(topbarThemeType));
            dispatch(changeLayout(layoutType));
            dispatch(changeSidebarImageType(leftSidebarImageType));
            dispatch(changeSidebarVisibility(sidebarVisibilitytype));
        }
    }, [layoutType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        leftsidbarSizeType,
        leftSidebarViewType,
        leftSidebarImageType,
        sidebarVisibilitytype,
        dispatch]);
    /*
    call dark/light mode
    */
    const onChangeLayoutMode = (value: any) => {
        if (changeLayoutMode) {
            dispatch(changeLayoutMode(value));
        }
    };

    const [headerClass, setHeaderClass] = useState<any>("");
    const [alertClass, setAlertClass] = useState<string>("");

    const selectuserProfile = createSelector(
        (state: any) => state.User,
        (user) => user?.user
    );
    const userProfile = useSelector(selectuserProfile);
    useEffect(() => {
        if (userProfile) {
            if (userProfile?.sellerStatus === "pending") {
                setAlertClass("alertShown");
            } else {
                setAlertClass("");
            }
        } else {
            setAlertClass("");
        }
    }, [dispatch, userProfile]);

    // class add remove in header
    useEffect(() => {
        window.addEventListener("scroll", scrollNavigation, true);
    });
    function scrollNavigation() {
        var scrollup = document.documentElement.scrollTop;
        if (scrollup > 50) {
            setHeaderClass("topbar-shadow");
        } else {
            setHeaderClass("");
        }
    }

    useEffect(() => {
        const humberIcon = document.querySelector(".hamburger-icon") as HTMLElement;
        if (sidebarVisibilitytype === 'show' || layoutType === "vertical" || layoutType === "twocolumn") {
            humberIcon?.classList?.remove('open');
        } else {
            humberIcon && humberIcon?.classList?.add('open');
        }
    }, [sidebarVisibilitytype, layoutType]);

    return (
        <React.Fragment>
            <div className={showSidebar ? '' : 'sidebar-hidden'} id="layout-wrapper">

                {!isSetSellerStore && !isChangePassword && (
                    <Header
                        headerClass={headerClass}
                        layoutModeType={layoutModeType}
                        onChangeLayoutMode={onChangeLayoutMode}
                    />
                )}
                {!isSetSellerStore && !isOnBoarding && !isChangePassword && (
                    <Sidebar layoutType={layoutType} />
                )}

               <div className={`${(!isSetSellerStore && !isChangePassword) ? "main-content" : ""} ${alertClass}`}>
                     {props.children}
               </div>

                {!isChangePassword &&  <MobileFooter />}
            </div>
   
        </React.Fragment>

    );
};

Layout.propTypes = {
    children: PropTypes.object,
};

export default withRouter(Layout);